module.exports = __webpack_public_path__ + "static/media/sc_3_i.39d1501a.png";